import { Controller } from "@hotwired/stimulus";

import Tablesort from "../utils/setupTablesort.js";

export default class extends Controller {
  static values = {
    ascClass: { type: String, default: 'sorted ascending' },
    descClass: { type: String, default: 'sorted descending' },
    hideEmpty: { type: Boolean, default: false }
  }

  connect() {
    if (this.element.tagName !== 'TABLE') {
      console.warn("Stimulus [table-sort] should be connected to a <table> element.");
      return
    }

    this.tablesort = new Tablesort(this.element, { hideEmpty: this.hideEmptyValue });

    // Hook into Tablesort’s native sorting events

    // This is actually just handled with SCSS extension now, using Aria

    // this.element.addEventListener('beforeSort', (event) => {
    //   this._clearSortClasses()
    // })

    // this.element.addEventListener('afterSort', (event) => {
    //   this._setSortClass(event.detail.column, event.detail.direction)
    // })
  }

  toggleHideEmpty(event) {
    this.hideEmptyValue = event.target.checked; // keep Stimulus value in sync
    this.tablesort.options.hideEmpty = this.hideEmptyValue;

    // re-run sorting with updated option
    this.tablesort.refresh();
  }

  _clearSortClasses() {
    const headers = this.element.querySelectorAll("thead th")
    headers.forEach(th => {
      th.classList.remove(this.ascClassValue.split(" "), this.descClassValue.split(" "))
    })
  }

  _setSortClass(th, direction) {
    if (!th) return
    if (direction === 'asc') {
      th.classList.add(this.ascClassValue)
    } else {
      th.classList.add(this.descClassValue)
    }
  }

  // TODO: Allow the element to be a target

}
